import React, { ReactNode } from 'react';
import { Link, Space, Icon } from '@tonic-ui/react';

interface ExternalLinkProps {
  children?: ReactNode;
  href: string;
  showIcon: boolean;
  className?: string;
  style?: Object;
  alt?: string;
  textDecoration?: string;
}

const defaultProps: Partial<ExternalLinkProps> = {
  showIcon: true,
};

// eslint-disable-next-line react/display-name
const ExternalLink = React.forwardRef<HTMLLinkElement, ExternalLinkProps>(
  (props, ref): JSX.Element => (
    <Link
      ref={ref}
      target="_blank"
      rel="noopener noreferrer"
      textDecoration={props?.textDecoration || 'underline'}
      {...props}
    >
      {props.children}
      {props.showIcon && (
        <>
          <Space width="2x" />
          <Icon icon="external-link" />
        </>
      )}
    </Link>
  )
);

// for passing default props to the component with forwardRef
ExternalLink.defaultProps = defaultProps;

export default ExternalLink;
